module.exports = __webpack_public_path__ + "assets/img/page-header-bg@2x.1228a610.png";